import React, { useCallback, useEffect, useMemo } from 'react';

import useAsyncActionStatus from '~/hooks/useAsyncActionStatus';
import { getFiles } from '~/store/files/actions';
import { FileHistoryModal, FilesList } from '~/components';

import { useModal } from '~/hooks/useModal';
import { getContractDetails } from '~/store/contracts/actions';
import { FilesContainer } from './Files.styled';

export type FilesProps = {
  id: string;
  contractDetailsActionId?: string;
};

export function Files({ id, contractDetailsActionId }: FilesProps) {
  const { openModal } = useModal();

  const getFilesControl = useAsyncActionStatus(getFiles, `CONTRACT_${id}`);

  const { result: contractDetails } = useAsyncActionStatus(getContractDetails, contractDetailsActionId);

  const files = useMemo(() => {
    const currentFiles = Array.isArray(getFilesControl.result) ? [...getFilesControl.result] : [];

    if (contractDetails?.ccbUrl) {
      const url = contractDetails.ccbUrl.startsWith('data:')
        ? contractDetails.ccbUrl
        : `data:application/pdf;base64,${contractDetails.ccbUrl}`;

      const ccbFile = {
        personImageId: null,
        type: 'CCB',
        personImageType: null,
        documentType: null,
        name: 'ccb-assinado',
        extension: '.pdf',
        canRequestResend: false,
        canUploadNew: true,
        canGenerateNew: false,
        url,
        uploadDate: null,
        personImageOrigin: null,
        userName: null,
        userId: null,
        size: null,
        inactive: false,
      };

      currentFiles.push(ccbFile);
    }

    return currentFiles;
  }, [getFilesControl.result, contractDetails?.ccbUrl]);

  const description = (
    <>
      É possível baixar os arquivos em massa ou bojo digital. <u>Os boletos tem validade de um dia útil.</u>
    </>
  );

  const handleShowHistory = useCallback(
    (file) => {
      openModal(
        <FileHistoryModal
          documentType={file.documentType}
          fileType={file.personImageType || file.type}
          id={id}
          type="CONTRACT"
        />,
        {
          title: 'Histórico da imagem',
          closable: true,
        },
      );
    },
    [id],
  );

  useEffect(() => {
    if (!getFilesControl.success) {
      getFilesControl.start({ type: 'CONTRACT', id }, { actionId: `CONTRACT_${id}` });
    }
  }, [id]);

  return (
    <FilesContainer>
      <FilesList
        id={id}
        type="CONTRACT"
        description={description}
        onHistoryClick={handleShowHistory}
        loading={getFilesControl.loading}
        files={files}
        allowedTypes={['FACEFRONT', 'FACEBIOMETRY', 'DOCUMENTFRONT', 'CCB']}
        allowUpload
      />
    </FilesContainer>
  );
}
